import { useEffect } from 'react'
import { useSession } from 'lib/session'

// The session bridge's client half: a page that finds itself signed in by a
// next-auth cookie navigates once through /api/auth/bridge, which signs the
// browser in to Kratos and comes back here (alby2/client/powerbox/KRATOS.md).
export function SessionBridge() {
  const { data } = useSession()
  const bridged = Boolean((data as { bridge?: boolean } | null)?.bridge)
  useEffect(() => {
    if (!bridged) return
    const here = window.location.pathname + window.location.search
    window.location.assign('/api/auth/bridge?return=' + encodeURIComponent(here))
  }, [bridged])
  return null
}
